import * as React from 'react';
import styles from "./styles.module.scss";
import { formatDateToBR } from "../../utils/time";

export function UserActionsContent({data = {}}) {
    const {atualizadoPor, criadoPor, dataCriacao, ultimaAtualizacao} = data;
    return (
        <div className={styles.containerUserActions}>
            {!!atualizadoPor && (
                <h5>
                    Atualizado em {" "}{formatDateToBR(ultimaAtualizacao)} por{" "}{atualizadoPor?.nome}
                </h5>
            )}
            
            {!!criadoPor && (
                <h5>
                    Criado em{" "}{formatDateToBR(dataCriacao)} por{" "}{criadoPor?.nome}
                </h5>
            )}
        </div>
    );
}
